import { includes, map, without } from 'lodash/fp';

import { EXCESS_TYPES } from '../../ahm-constants/ui';
import { GET_PRODUCT_EXCESS } from './query.gql';
import apolloClient from '../../graphql/client';
import getSaleableProductIds from '../get-saleable-product-ids';

const valuesToOmit = [null];

// @ts-expect-error - Automatic, Please fix when editing this file
const fetchSingleProductExcess = async ({ saleableProductIds, excess, parentProductId }) => {
  const productId = `${parentProductId}-excess-${excess}`;
  if (!includes(productId, saleableProductIds)) {
    return null;
  }
  try {
    const { data } = await apolloClient.query({
      query: GET_PRODUCT_EXCESS,
      variables: { id: productId },
    });
    return data?.product?.charges?.excess?.amount;
  } catch (error) {
    // if we hit this statement then we return null to say no excess was returned
    return null;
  }
};

/**
 * Fetches the applicable excess amounts for a parent product id.
 *
 * @param {object} param - An object.
 * @param {number} param.parentProductId - The parent of of the product to return the applicable excess values for.
 */
// @ts-expect-error - Automatic, Please fix when editing this file
const fetchProductExcess = async ({ parentProductId }) => {
  const saleableProductIds = getSaleableProductIds();
  const productExcessPromises = map(
    (excess) => fetchSingleProductExcess({ excess, parentProductId, saleableProductIds }),
    EXCESS_TYPES,
  );
  const excessTypes = await Promise.all(productExcessPromises);
  // we are using without instead of compact, because we dont want to throw away 0 values
  return { [parentProductId]: without(valuesToOmit, excessTypes) };
};

export default fetchProductExcess;
